import tenant from '@/config/tenant'
import axios from 'axios'

export default {
  getAccount(accessToken, countryCode) {
    const client = axios.create({ baseURL: tenant.buildTenantUrl() })

    return client.get('/auth/me/get-account', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        country: `${countryCode}`
      }
    })
  },

  reset(email) {
    const client = axios.create({ baseURL: tenant.buildTenantUrl() })

    return client.post('/auth/password', { email })
  },

  getUserAndAccount(accessToken, countryCode) {
    const client = axios.create({ baseURL: tenant.buildTenantUrl() })

    return client.get('/auth/user-and-account', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Access-Control-Allow-Origin': '*',
        country: `${countryCode}`
      }
    })
  }
}
